var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 229,
    viewBox: "0 0 200 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 114.286C84.8448 114.286 70.3103 108.265 59.5939 97.549C48.8775 86.8326 42.8571 72.2981 42.8571 57.1429C42.8571 41.9876 48.8775 27.4531 59.5939 16.7368C70.3103 6.02039 84.8448 0 100 0C115.155 0 129.69 6.02039 140.406 16.7368C151.122 27.4531 157.143 41.9876 157.143 57.1429C157.143 72.2981 151.122 86.8326 140.406 97.549C129.69 108.265 115.155 114.286 100 114.286ZM93.3482 160.357L85.0446 146.518C82.1875 141.741 85.625 135.714 91.1607 135.714H100H108.795C114.33 135.714 117.768 141.786 114.911 146.518L106.607 160.357L121.518 215.67L137.589 150.089C138.482 146.473 141.964 144.107 145.58 145.045C176.875 152.902 200 181.205 200 214.866C200 222.455 193.839 228.571 186.295 228.571H127.455C126.518 228.571 125.67 228.393 124.866 228.08L125 228.571H75L75.1339 228.08C74.3304 228.393 73.4375 228.571 72.5446 228.571H13.7054C6.16071 228.571 0 222.411 0 214.866C0 181.161 23.1696 152.857 54.4196 145.045C58.0357 144.152 61.5179 146.518 62.4107 150.089L78.4821 215.67L93.3929 160.357H93.3482Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIuser);
export default __webpack_public_path__ + "static/media/iuser.8f4611d65e210383e7686845b241343a.svg";
export { ForwardRef as ReactComponent };